import React from 'react';
import cn from 'classnames';
// Styles
import styles from './VerticalStepper.module.scss';

export type VerticalStepperNodeStep = {
  type: 'content' | 'post' | 'appearance';
  node: React.ReactNode;
};

type VerticalStepperProps = {
  nodeSteps: VerticalStepperNodeStep[];
  activeStep: number;
  className?: string;
};

const VerticalStepper: React.FC<VerticalStepperProps> = ({
  nodeSteps,
  activeStep,
  className,
}) => {
  return (
    <div className={cn(styles.root, className)}>
      {nodeSteps.map((step, index) => {
        const isActive = index === activeStep;
        const isCompleted = index < activeStep;

        return (
          <div
            key={index}
            className={cn(styles.stepContainer, {
              [styles.completed]: isCompleted,
            })}
          >
            <div className={styles.stepWrapper}>
              <div className={styles.stepIndicator}>
                <div
                  className={cn(styles.stepCircle, {
                    [styles.active]: isActive,
                    [styles.completed]: isCompleted,
                  })}
                >
                  {isCompleted ? (
                    <div className={styles.checkmark}>✓</div>
                  ) : (
                    <div className={styles.stepNumber}>{index + 1}</div>
                  )}
                </div>
              </div>

              <div className={styles.stepContent}>{step.node}</div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default VerticalStepper;
